export const FETCH_LIST_PRICE_BOARD_REQUEST = 'FETCH_LIST_PRICE_BOARD_REQUEST';
export const FETCH_LIST_PRICE_BOARD_SUCCESS = 'FETCH_LIST_PRICE_BOARD_SUCCESS';
export const FETCH_LIST_PRICE_BOARD_FAILURE = 'FETCH_LIST_PRICE_BOARD_FAILURE';
